import { BackgroundStyle } from './StatusBar.theme.utils';

var getVariant = variant => ({
  container: {
    bgColor: BackgroundStyle[variant],
    color: 'neutral.black'
  }
});

export var statusBarTheme = {
  baseStyle: {
    container: {
      borderTopRadius: 'l',
      display: 'flex',
      py: 'm',
      px: 'l',
      gridGap: 'm'
    },
    content: {
      textStyle: 'body3Semi',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      flex: 1
    },
    icon: {
      display: 'flex'
    }
  },
  variants: {
    info: getVariant('info'),
    success: getVariant('success'),
    warning: getVariant('warning'),
    critical: getVariant('critical'),
    neutral: getVariant('neutral')
  },
  defaultProps: {
    variant: 'info'
  }
};
//# sourceMappingURL=StatusBar.theme.js.map